import { Label } from '@r1-frontend/ui-react/components/label';

import Widget from '~/src/components/Widget';
import { dateWithoutYear } from '~/src/helpers/date';
import { ITvPackageState } from '~/src/store/reducers/tvPackages';

import * as ST from './styled';

interface IProps {
    isActive: boolean,
    tvPacketState?: ITvPackageState,
    tryAndBuyLabel?: string,
}

const LabelAndActivity = ({ isActive, tvPacketState, tryAndBuyLabel }: IProps): JSX.Element | null => {
    const activityPeriod = tvPacketState?.dateOff ? `до ${dateWithoutYear(new Date(tvPacketState.dateOff * 1000))}` : '';
    const activity = isActive ? `Активен ${activityPeriod}` : '';

    if (tryAndBuyLabel || activity) {
        return (
            <ST.LabelsWrapper>
                {tryAndBuyLabel && <Label type={'LabelsText_2'}>{tryAndBuyLabel}</Label>}
                {activity && <Widget.PeriodData>{activity}</Widget.PeriodData>}
            </ST.LabelsWrapper>
        );
    }
    return null;
};

export default LabelAndActivity;
